import RoomAllotmentContractDetail from './RoomAllotmentContractDetail';

export default RoomAllotmentContractDetail;